import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "../lib/api";

export default function Objects() {
  const [objects, setObjects] = useState([]);
  useEffect(() => { api.get("/objects").then((r) => setObjects(r.data)).catch(() => {}); }, []);

  return (
    <main data-testid="objects-page" className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20 pt-40 md:pt-52 pb-16">
      <header className="border-b hairline pb-8 mb-16">
        <div className="label mb-6">Physical Works</div>
        <h1 className="font-display font-800 uppercase leading-[0.9] tracking-[-0.02em] text-6xl md:text-8xl">Objects</h1>
        <p className="mt-8 text-[var(--muted)] max-w-xl">
          Physical manifestations of RCKT beyond the numbered paper archive. Art objects, not merchandise.
        </p>
      </header>

      <div className="space-y-32 md:space-y-48">
        {objects.map((o, i) => (
          <motion.div
            key={o.slug}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="grid grid-cols-1 md:grid-cols-12 gap-10 items-center"
          >
            <Link to={`/objects/${o.slug}`} data-testid={`object-card-${o.slug}`} className={`group block overflow-hidden bg-white border hairline md:col-span-7 ${i % 2 ? "md:order-2 md:col-start-6" : ""}`}>
              <img src={o.image} alt={o.label} className="art-img w-full h-[75vh] object-cover" loading="lazy" />
            </Link>
            <div className={`md:col-span-4 ${i % 2 ? "md:order-1 md:col-start-1" : "md:col-start-9"}`}>
              <div className="label mb-3">{o.label}</div>
              <div className="font-display font-700 text-4xl md:text-5xl uppercase">{o.title}</div>
              <div className="text-[var(--muted)] mt-4">{o.year}</div>
              <div className="text-[var(--muted)] mt-1">{o.medium}</div>
              <p className="mt-6 text-[var(--muted)] leading-relaxed max-w-sm">{o.description}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </main>
  );
}
